module.exports = __webpack_public_path__ + "img/setup1.adc73580.png";